// extracted by mini-css-extract-plugin
export var socialMedias = "SocialMedias-module--socialMedias--05be3";